module.exports = __webpack_public_path__ + "static/img/bat-ss.bc2427c8.png";